import type { PoolShipping } from '../../lib/api/operatorConsole';

interface Props {
  shipping: Pick<PoolShipping, 'status' | 'humanized_status'>;
}

// Delivered and shipped are progress, canceled is not, and the rest are still
// waiting on something. The words come from the backend (`humanized_status`,
// which folds per-card refunds in) — only the colour is decided here.
const TONE: Record<string, string> = {
  delivered: 'var(--co-success)',
  shipped: 'var(--co-brand)',
  canceled: 'var(--co-error)',
};

export function StatusPill({ shipping }: Props) {
  // Anything still being worked (pending, waiting for payment, paid, merged)
  // reads as neutral — it is not progress and not a problem.
  const color = TONE[shipping.status] ?? 'var(--co-muted)';

  return (
    <span
      className="inline-block rounded px-2 py-0.5 text-[11px] font-medium"
      style={{
        color,
        backgroundColor: `color-mix(in srgb, ${color} 12%, transparent)`,
      }}
    >
      {shipping.humanized_status || shipping.status}
    </span>
  );
}
